import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      <h1>Page not found </h1>
    </div>
  );
};

export default PageNotFound;
